export enum NetworkStatus {
    Online = 'online',
    Offline = 'offline'
  }